import { UISubscriptionOverlayController } from '../../../../shared/scripts/store/subscription_overlay/UISubscriptionOverlayController.ts';
import { UIDStoreMembershipTabsController } from '../../../../shared/scripts/store/UIDStoreMembershipTabsController.ts';
import { UIDStoreMembershipProductView } from '../UIDStoreMembershipProductView.ts';
export class UIDSubscriptionOverlayController extends UISubscriptionOverlayController {
    createMembershipProductView(membershipProduct) {
        return new UIDStoreMembershipProductView(this.membershipsDiv, this.overlayState, membershipProduct);
    }
    createMembershipTabsController(monthlyTab, annualTab) {
        return new UIDStoreMembershipTabsController(this.overlayState, monthlyTab, annualTab);
    }
}
